import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import { CollapsiblePanel } from '@forwardfinancing/component-library';
import { trackUserClick } from '@forwardfinancing/analytics-frontend-library';
import * as actions from '../../../actions/contactActions';
import { ContactItem } from './ContactItem';
import linkUtils from '../../../lib/linkUtils';
import utils from '../../../lib/utils';

export class ContactsPanel extends React.Component {
  constructor(props, context){
    super(props, context);

    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount() {
    this.fetchContacts();
  }

  componentDidUpdate(prevProps) {
    const {partner_id: previousPartnerId} = prevProps.selectedPartner || {};
    const {partner_id} = this.props.selectedPartner || {};

    if (previousPartnerId !== partner_id) {
      this.fetchContacts({ partner_id });
    }
  }

  fetchContacts(partner={}) {
    const {actions: {fetchContacts}} = this.props;

    fetchContacts(partner);
  }

  isContactEmpty() {
    return Object.keys(this.props.contacts).length === 0;
  }

  compactContacts() {
    return utils.compactArray([
      this.props.contacts.account_manager
    ]);
  }

  areContactsEmpty() {
    return this.compactContacts().length === 0;
  }

  shouldDisplayDefaultContact() {
    return this.isContactEmpty() || this.areContactsEmpty();
  }

  mapContactsWithTitles(array) {
    if (utils.isArray(array)) {
      return array.map((item)=>{
        if (item.contact){
          return <ContactItem title={item.title} {...item.contact} key={item.key} />;
        } else {
          return null;
        }
      });
    }
  }

  renderContent() {
    if (this.shouldDisplayDefaultContact()) {
      return [(<ContactItem key="0"/>)];
    } else {

      const contactsWithTitles = [
          {
            title: "Account Manager",
            contact: this.props.contacts.account_manager,
            key: 'manager'
          }
        ];

      const nodes = this.mapContactsWithTitles(contactsWithTitles);
      return utils.compactArray(nodes);
    }
  }

  handleClickTrack() {
    const page = linkUtils.getLocationName(window);
    trackUserClick({attribute: 'Contact Us', source: page});
  }

  render() {
    return (
      <CollapsiblePanel
        collapsedCaption="Contact Us"
        expandedCaption="Get in Touch"
        subComponent={this.renderContent()}
        clickTrack={this.handleClickTrack.bind(this)}
      />
    );
  }
}

function mapStateToProps(state){
  return {
    contacts: state.contacts,
    selectedPartner: state.partner.selected
  };
}

function mapDispatchToProps(dispatch){
  return{
    actions: bindActionCreators(actions, dispatch)
  };
}

ContactsPanel.propTypes = {
  contacts: PropTypes.object,
  selectedPartner: PropTypes.object,
  actions: PropTypes.object.isRequired
};

ContactsPanel.defaultProps = {
  contacts: {},
  selectedPartner: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactsPanel);
